var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{class:{'active':_vm.isExactActive},on:{"click":function($event){$event.stopPropagation();return _vm.onTabItemClick.apply(null, arguments)}}},[_c('a',{staticClass:"a-tab-link",attrs:{"data-toggle":"tab"}},[_vm._v(" "+_vm._s(_vm.header)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }